/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
$(document).ready(function(){
//   var chart_width = $('.size-chart').width();
//   alert(chart_width);
  var closeButtons = $('.toggleChart');
  closeButtons.on('click', function() {
//     alert();
    $('.size-chart').toggle();
//       function(){$(this).css({"right": "translateX(0)"});}
//     );
//     $('.size-chart').css('transform','translateX(0)');
  });
});

//Pick.js

(function( $ ){
  $.fn.pick = function(how_many) {

    var how_many = how_many || 2;

    // Picking random numbers without repeating. 
    var index_array = [];
    var original_obj_size = this.length;
    for (var i=0; i<original_obj_size; i++) {
      index_array.push(i);
    }
    //+ Jonas Raoni Soares Silva
    //@ http://jsfromhell.com/array/shuffle [rev. #1]
    var shuffle = function(v) {
      for (var j, x, i = v.length; i; j = parseInt(Math.random() * i), x = v[--i], v[i] = v[j], v[j] = x);
      return v;
    };
    var new_index_array = shuffle(index_array).slice(0,how_many);

    // Ditching unpicked elements and removing those from the returned set.
    return this.each(function(i) {
      if ($.inArray(i,new_index_array) === -1) {
        $(this).remove();
      }
    }).filter(function() {
      if (this.parentNode === null) {
        return false;
      }
      else {
        return true;
      }
    });

  };
})( jQuery );

$(document).ready(function() {
  $('#upsell_product--1 > .product-loop').pick(8);
  $('#upsell_product--2 > .product-loop').pick(8);
  
  $('#upsell_product--slider-1 > .product-loop').pick(8);
  $('#upsell_product--slider-2 > .product-loop').pick(8); 
  
  
});
$(document).ready(function() {
  $(".mobile_toggle_desc").on('click', function (){
    $(".toggle_desc").toggleClass("slide");
    if ($(".toggle_desc").hasClass("slide")) {
      $(this).find('span').addClass("arrow-up").removeClass("arrow-down");
    }
    else { $(this).find('span').addClass("arrow-down").removeClass("arrow-up"); }
  }); 
});
